export default __webpack_public_path__ + "static/media/media_earnings.ea79d316.svg";